<template>
  <!-- 支付弹框 -->
  <el-dialog
    class="payDialog"
    title=""
    :visible.sync="showPop"
    :close-on-click-modal="false"
		:close-on-press-escape="false"
    width="410px"
  >
		<div class="close-dialog" @click="closeSheet">
			<el-icon class="el-icon-close"></el-icon>
		</div>
    <div class="contentInfos">
      <div class="title">资金密码</div>
      <div class="payInfo">
        <div class="firstRow">
          <div class="name">
            {{ typeName }}
          </div>
          <div class="result">
            {{ price }}
          </div>
        </div>
        <div class="twoRow">
          <div class="topTitle">
            <span class="name">资金密码</span>
          </div>
          <div class="fieldWrap">
            <el-input v-model="pwd" :type="passwordShow" placeholder="请输入支付密码" :maxlength="6" @input="handleEdit">
            </el-input>
            <div class="iconWrap" @click="changePasswordShow">
              <img
                v-if="passwordShow == 'password'"
                width="24px"
                class="imgClick"
                :src="closeEye"
                alt=""
              >
              <img
                v-else
                width="24px"
                class="imgClick"
                :src="openEye"
                alt=""
              ></div>
          </div>
        </div>
      </div>
      <div class="actionWrap">
        <span class="btns" @click="closeSheet()">取消</span>
        <span class="savebtn" @click="surePwd()">确认</span>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
			currentStatus: false, // 测试
      showPop: false,
      price: null,
      pwd: '',
      typeName: '支付余额',
      passwordShow: 'password',
      closeEye: require('../../../assets/images/pt-closeEye.png'),
      openEye: require('../../../assets/images/pt-openEye.png')
    }
  },
  methods: {
    showSheet(price, typeName) {
      this.price = price
      this.typeName = typeName
      this.showPop = true
    },
    goForgetPwd() {
      this.$message('敬请期待')
    },
    surePwd() {
			this.currentStatus = true
      if (this.pwd.length !== 6) {
        this.$message('请输入6位数的资金密码')
				this.currentStatus = false
        return
      }
      this.$emit('surePay', this.pwd)
    },
    handleEdit(e) {
      this.pwd = e.replace(/[^0-9]+/g, '') // 输入非数字，会被替换成空
    },
    changePasswordShow() {
      if (this.passwordShow == 'password') {
        this.passwordShow = 'text'
      } else {
        this.passwordShow = 'password'
      }
    },
    closeSheet() {
			if (this.currentStatus) return
			this.handleGiveUpPay()
    },
		// 放弃支付
		handleGiveUpPay() {
			this.$confirm('确认放弃支付?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				confirmButtonClass: 'giveUpConfirmButton',
				cancelButtonClass: 'giveUpcancelButton',
				type: 'warning'
			}).then(() => {
				this.showPop = false
      	this.pwd = ''
				this.$emit('closePay')
				setTimeout(() => {
					this.$router.replace(`/orderManagement/12`)
				})
			})
		}
  }
}
</script>
<style lang="scss">
.giveUpConfirmButton {
	background: linear-gradient(to right, #EA553C, #EE8C54) !important;
	border: none;
	width: 100px;
	height: 30px;
	border-radius: 30px;
}
.giveUpcancelButton {
	background: #eeeeee !important;
	width: 100px;
	height: 30px;
	border: none;
	border-radius: 30px;
	color: #999999;
	&:hover {
		color: #999999;
	}
}
</style>
<style lang="scss" scoped>
.payDialog{
	/deep/.el-dialog{
		background: #FFFFFF!important;
	}
	/deep/.el-dialog__header{
		display: none;
	}
	/deep/.el-dialog__body{
		padding: 20px 30px 0;
		position: relative;
		height: 267px;
		box-sizing: border-box;
		.close-dialog {
			position: absolute;
			right: 20px;
			top: 23px;
			color: #D9D9D9;
			width: 20px;
			height: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			.el-icon-close {
				font-size: 20px;
			}
		}
	}
	.title{
		font-size: 16px;
		font-family: PingFang TC-Regular;
		color: #333333;
		text-align: center;
	}
	.payInfo{
		margin-top:20px;
		.firstRow{
			height: 45px;
			border-radius: 4px 4px 4px 4px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.name{
				font-size: 14px;
				font-family: PingFang TC-Regular;
				color: #333333;
				white-space: nowrap;
			}
			.result{
				font-size: 14px;
				font-family: PingFang TC-Regular;
				color: #999999;
				border: 1px solid #D9D9D9;
				width: 284px;
				height: 38px;
				line-height: 36px;
				padding-left: 8px;
				box-sizing: border-box;
			}
		}
		.twoRow {
			margin-top: 20px;
			display: flex;
			align-items: center;
			.topTitle{
				display: flex;
				justify-content: space-between;
				align-items: center;
				.name{
					font-size: 14px;
					font-family: PingFang TC-Regular;
					font-weight: 400;
					color: #333333;
				}
				.forgetPwd{
					font-size: 16px;
					font-family: PingFang TC-Regular;
					font-weight: 400;
					color: #333333;
					cursor: pointer;
				}
			}
			.fieldWrap{
				margin-left: 10px;
				position: relative;
				width: 284px;
				height: 38px;
				/deep/ .el-input {
					height: 100%;
					.el-input__inner{
						background: #ffffff;
						border: 1px solid #D9D9D9 !important;
						color: #bfc3ce;
						height: 38px;
						line-height: 36px;
						border-radius: 0;
					}
				}
				.iconWrap{
					position: absolute;
					width: 15px;
					height: 15px;
					right: 10px;
					top: 50%;
					transform: translateY(-50%);
					cursor: pointer;
					img {
						width: 100%;
						height: 100%;
					}
				}
			}
		}
	}
	.actionWrap{
		margin-top: 33px;
		display: flex;
		justify-content: center;
		.btns{
			display: inline-block;
			width: 156px;
			height: 40px;
			border-radius: 40px;
			font-size: 20px;
			font-family: PingFang TC-Regular;
			line-height: 40px;
			text-align: center;
			cursor: pointer;
			background: #F4F4F4;
			color: #999999;
		}
		.savebtn{
			margin-left: 20px;
			width: 156px;
			display: inline-block;
			border-radius: 40px;
			height: 40px;
			font-size: 20px;
			font-family: PingFang TC-Regular;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			color: #FFFFFF;
			background: linear-gradient(to right, #EA553C, #EE8C54);
		}
	}
}
</style>

